import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Wrapper, TextField, TextArea, SelectField ,FormTitle,ImageUpload, DateTimeTextField} from "../controllers/controllers";
import * as Yup from "yup";
import styles from "../controllers/controllers.module.css";
import { EditButton, Submit } from "../../../../components/button/buttons";
import IMAGES from "../../../../assets/images/images";
import {connect} from "react-redux";
import {setIncidentPreviewMode} from "../../../../redux/actions/incidentManagement/raiseIncident.action";
import { Yes_No_Options,IVC_CALL_FAILURE_SUBTYPE_OPTIONS,Priority_Options, ADD_TICKET_ACTION, MY_INCIDENT_TABS, MAX_FILES, TOOLTIPS, incidentTimeInterval, incidentTimePlaceHolder, Priority_Options_For_IVC, FromLabel} from "../../../../utils/constants/incidentConstants";
import {convertToTimestampObject, getLabelFromValue} from "../../../../utils/arrayUtils"
import {SubmitIncident} from "../../../../redux/actions/incidentManagement/raiseIncident.action";
import {openAlertPopup} from "../../../../redux/actions/Alert/alert.action";
import {getIncidentList} from "../../../../redux/actions/incidentManagement/incidentList.action";
import { incidentDownloadFiles } from "../../../../redux/actions/fileAttachment/fileAttachment.actions";
import { setIncidentActiveTab } from "../../../../redux/actions/incidentManagement/incidentTab.action";
import moment from 'moment';
import { showErrorPopup } from "../../../../redux/actions/customErrorPopup/customerrorpopup.action";
import { useNavigate } from "react-router-dom";
import { getModuleNotification } from "../../../../redux/actions/notification/getModuleNotification.action";
import { useDateLimits } from "../../../../hooks/useDateLimits";
import { DateTimePicker } from "../../../../components/dateTimePicker/DateTimePicker";
import { renderTooltipList } from "../../../../utils/utils";
import MultipleEmailInput from "../../../../components/multipleEmailInput/MultipleEmailInput";


const IVCSIPTrunkConnectivityIssues = ({ service_type, issue_type, failure_type,parentFormData,actionType, incidentData, ...props }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const navigate = useNavigate();
    const { dateLimits, handleCalendarOpen,getTimeProps} = useDateLimits(true);
    const onFileDownload=(file)=>{
        props.incidentDownloadFile(file.originalFileName,file.uniqueFileName,file.messageId,file.attachmentId,file.graphInternetMessageId)
        .then((result)=>{
            if(!result.status){
                alert("Error while downloding file!");
            }
        }).catch((error)=>{
        alert("Something went wrong!")
        })
    }
    let initialValues = {}
    if(actionType===ADD_TICKET_ACTION.INCIDENT_DETAILS){
        initialValues = {
        issue_summary: incidentData?.issueDetails?.title,
        ip_end_points:incidentData?.issueDetails?.IPEndPoints,
        problem_statement:incidentData?.issueDetails?.problemStatement,
        date_time:incidentData?.issueDetails?.issueStartedDateTime,
        sip_trace_text:incidentData?.issueDetails?.SIPTracesText,
        sip_trace_file:incidentData?.issueDetails?.SIPTracesAttachment,
        priority:incidentData?.issueDetails?.priority,
        additionalEmails:incidentData?.issueDetails?.additionalEmails, 
        additional_information:incidentData?.issueDetails?.additionalInformation
        };
    }else{
      initialValues ={
        issue_summary: '',
        ip_end_points:'',
        problem_statement:'',
        date_time:'',
        sip_trace_text:'',
        sip_trace_file:[],
        priority:'',
        additionalEmails:[],
        additional_information:'',
        impactedSubscriber:null,
     };
    }
    // oneitsm_api_integration: Validation interim MAX_FILES: 15 file and OneITSM MAX_FILES:1 file
    const validationSchema = Yup.object().shape({
        issue_summary: Yup.string().max(100, "Issue summary must be at most 100 characters").required("Required"),
        ip_end_points: Yup.string().required("Required"),
        problem_statement:Yup.string().max(1000, "Problem statement must be at most 1000 characters").required("Required"),
        date_time:Yup.string().required("Required")
        .test({
            name: 'Time',
            message: "Future Date or Time not allowed.",
            test: function(value) {
                const currentDateTime = moment().utc().format('YYYY-MM-DDTHH:mm')
              if (value>currentDateTime) {
                return false;
              }
              return true;
            }
          }),
        sip_trace_text:Yup.string().max(1000, "SIP Traces must be at most 1000 characters"),
        sip_trace_file:Yup.array().max(MAX_FILES),
        priority: Yup.string(),
        additionalEmails: Yup.array().of(Yup.string().trim().email("Please enter a valid email address.")),
        additional_information:Yup.string().max(1000, "Text must be at most 1000 characters")
    })
    

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
                if(props.isIncidentPreviewModeOn){
                    setIsSubmit(true);                                 
                let obj = {
                    incidentServiceType: parentFormData.service_type,
                    incidentFaultType: parentFormData.issue_type,
                    failureRelatedType: parentFormData.failure_type,
                    impactedSubscriber: parentFormData.impacted_subscriber,
                    uniqueCustomerRefId:props.myRights?.customerUserMetaInfo?.uniqueCustomerRefId,
                    issueDetails: {
                            title: values.issue_summary,
                            IPEndPoints: values.ip_end_points,
                            problemStatement: values.problem_statement,
                            issueStartedDateTime: values.date_time,
                            issueStartedTimeStampUNIX:convertToTimestampObject(values?.date_time),
                            SIPTracesText: values.sip_trace_text,
                            SIPTracesAttachment: values.sip_trace_file,
                            priority: values.priority,
                            additionalEmails:values.additionalEmails,
                            additionalInformation: values.additional_information
                    }               
                  };      
                props.addIncident(obj).then((result) => {        
                  if (result.status) {
                    props.openAlertPopup({
                      message: `A new incident with ID: ${result?.res?.data?.ticketIdServiceDesk} has been created.`,
                      image: IMAGES.success
                    });
                    if(props.incidentActiveTab===MY_INCIDENT_TABS.MY_SERVICE_REQUEST){
                        props.setIncidentActiveTab(MY_INCIDENT_TABS.MY_INCIDENTS);
                        navigate('/incident-management/incidents');
                    }           
                    setIsSubmit(false);
                    props.closeForm();
                    resetForm();
                    props.getIncidentList();
                    props.getModuleNotification();
                  } else {
                    if(result.code === 500){
                        const errormsg = <div>Service temporarily unavailable. Please try again later.<div style={{marginTop:'10px'}}>If the issue persists while using the portal, you may report it via email at cscvcs@vodafone.com with relevant details. </div></div>
                        props.showErrorPopup({errorHeader:"Service Unavailable"},{errorMessage:errormsg},{isnote:true });
                        setIsSubmit(false);
                        }else{
                    let error_msg = result?.error;
                    props.openAlertPopup({
                      message: error_msg,
                      image: IMAGES.error,
                      isFormOpen:true
                    }); } 
                    setIsSubmit(false);
                   // props.closeForm();
                  }
                })
                .catch((error) => {
                  props.openAlertPopup({
                    message: "An error occurred while processing your request. Please try again later.",
                    image: IMAGES.error,
                    isFormOpen:true
                  }); 
                   setIsSubmit(false);
                 //  props.closeForm();
                });
            }else{
                props.setIncidentPreviewMode(true);
            }
            }}
        >
            {({ isValid, dirty, setFieldValue, values, handleChange, handleSubmit, handleBlur, resetForm }) => {
                const timeProps = getTimeProps(values.date_time);
                return(
                <>
                    <FormTitle
                        title={actionType===ADD_TICKET_ACTION.INCIDENT_DETAILS?null:(props.isIncidentPreviewModeOn?"Please Check The Details":"Please Provide The Details")}
                    />
                    <Form 
                        id="ivc_sip_trunk_connectivity_issues"
                        className={styles.form}
                        onSubmit={handleSubmit}
                    >
                        <TextField
                            label="Title"
                            type="text"
                            name="issue_summary"
                            isMandatory={true}
                            placeholder="Enter here"
                            isExpandedField={true}
                            showTooltip={true}
                            tooltipText={renderTooltipList(TOOLTIPS.TITLE)}
                            textLimit={`${values?.issue_summary?.length}/100 characters`}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                         <TextField
                            label="IP End Points"
                            name="ip_end_points"
                            isMandatory={true}
                            type="text"
                            placeholder="Enter here"
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={renderTooltipList(TOOLTIPS.IP_END_POINT)}
                            textLimit={null}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <TextArea
                            label="Problem Statement"
                            name="problem_statement"
                            isMandatory={true}
                            placeholder="Enter the issue you are facing..."
                            isExpandedField={true}
                            showTooltip={true}
                            tooltipText={renderTooltipList(TOOLTIPS.PROBLEM_STATEMENT)}
                            textLimit={`${values?.problem_statement?.length}/1000 characters`}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                         <DateTimePicker
                            label="Date & Time of Issue Started (In GMT)"
                            name="date_time"
                            isMandatory={true}
                            placeholder={incidentTimePlaceHolder}
                            isExpandedField={false}
                            showTooltip={true}
                            tooltipText={renderTooltipList(TOOLTIPS.DATE_TIME)}
                            textLimit={null}
                            max={moment().format('YYYY-MM-DDTHH:mm')}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                            onCalendarOpen={handleCalendarOpen}
                            isUTCMode={true}
                            datePickerProps={{
                                showTimeSelect: true,
                                timeIntervals:incidentTimeInterval,
                                timeFormat: "HH:mm",
                                dateFormat: "dd/MM/yyyy HH:mm",
                                maxDate: dateLimits?.maxDate,
                                ...timeProps,
                                showMonthDropdown: true,
                                showYearDropdown: true,
                                popperPlacement: "bottom-start",
                            }}
                        />
                        <SelectField
                            label={"Priority"}
                            name="priority"
                            placeholder="Choose priority"
                            options={Priority_Options_For_IVC}
                            onChange={(e) => {
                                handleChange(e);
                            }}
                            showTooltip={true}
                            tooltipText={renderTooltipList(TOOLTIPS.PRIORITY)}
                            isExpandedField={false}
                            isMandatory={false}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                         <div className={styles.expandedField}>
                         <MultipleEmailInput
                            name="additionalEmails"
                            label={FromLabel.additional_Email}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                            requestorEmail={props?.myRights?.email}
                            showTooltip={true}
                            isNote={true}
                            tooltipText={"Additional Emails"}
                        /> 
                        </div>
                        <TextArea
                            label="SIP Traces or Attachments"
                            name="sip_trace_text"
                            isMandatory={false}
                            placeholder="Enter the issue you are facing..."
                            isExpandedField={true}
                            showTooltip={true}
                            tooltipText={renderTooltipList(TOOLTIPS.SIP_TRACE_ATTACHMENT)}
                            textLimit={`${values?.sip_trace_text?.length}/1000 characters`}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                        <ImageUpload
                            name="sip_trace_file"
                            value={values.sip_trace_file}
                            setFieldValue={setFieldValue}
                            isMandatory={false}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                            onFileDownload={onFileDownload}
                            actionType={actionType}
                        />
                        <TextArea
                            label="Additional Information"
                            name="additional_information"
                            isMandatory={false}
                            placeholder="Enter here"
                            isExpandedField={true}
                            showTooltip={true}
                            tooltipText={renderTooltipList(TOOLTIPS.ADDITIONAL_INFORMATION)}
                            textLimit={`${values?.additional_information?.length}/1000 characters`}
                            isPreviewMode={props.isIncidentPreviewModeOn}
                        />
                    </Form>
                    {actionType===ADD_TICKET_ACTION.INCIDENT_DETAILS?
                         <footer className={`${styles.footer} ${actionType===ADD_TICKET_ACTION.INCIDENT_DETAILS ?styles.closedetalpopup:""}`}>
                            <EditButton
                            className={styles.backButton}
                            title={"Close"}
                            style={styles.btn}
                            onClick={()=>{
                                props.setIncidentPreviewMode(false);
                                props.closeForm();
                            }}/>
                         </footer>:
                    <footer className={styles.footer}>
                        {
                           props.isIncidentPreviewModeOn? 
                           <EditButton
                            className={styles.backButton}
                            title={"Edit"}
                            style={styles.btn}
                            onClick={()=>props.setIncidentPreviewMode(false)}
                        />:<EditButton
                            className={styles.backButton}
                            title={"Cancel"}
                            style={styles.btn}
                            onClick={()=>{
                                props.setIncidentPreviewMode(false);
                                props.closeForm();
                            }}
                        />
                        }
                        <Submit
                            id="saveButton"
                            title={props.isIncidentPreviewModeOn?"Submit":"Preview"}
                            form="ivc_sip_trunk_connectivity_issues"
                            style={styles.btn}
                            isSubmitting={isSubmit}
                            disabled={!isValid || !dirty}
                        />
                    </footer>
}
                </>
            )}}

        </Formik>
    )

}

const mapStateToProps = (state)=>{
    return {
        isIncidentPreviewModeOn:state.IncidentManagement.isIncidentPreviewModeOn,
        myRights:state.myRights.myRights,
        incidentActiveTab:state.incidentTab.incidentActiveTab, 
    }
  }

const mapDispatchToProps = (dispatch)=>{
    return {
        setIncidentPreviewMode: (payload) => {
            return dispatch(setIncidentPreviewMode(payload))
        },
        addIncident: (payload) => {
            return dispatch(SubmitIncident(payload))
        },
        openAlertPopup: (payload) => {
            return dispatch(openAlertPopup(payload))
          },
          getIncidentList: (next=null)=>{
              return dispatch(getIncidentList(next))
          },
        incidentDownloadFile:(originalFileName,uniqueFileName,messageId,attachmentId,graphInternetMessageId)=>{
            return dispatch(incidentDownloadFiles(originalFileName,uniqueFileName,messageId,attachmentId,graphInternetMessageId))
        },
        setIncidentActiveTab: (tab) => {
            return dispatch(setIncidentActiveTab(tab))
        },
        showErrorPopup: (errorHeader,errormessage,isnote) => {
            return dispatch(showErrorPopup(errorHeader,errormessage,isnote))
        },
        getModuleNotification: () => {
             return dispatch(getModuleNotification())
        },
    }
  };
  
export default connect(mapStateToProps, mapDispatchToProps)(IVCSIPTrunkConnectivityIssues);

